// Recovered compiled webpack factory 41209. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "callServer", {
      enumerable: !0,
      get: function () {
        return i;
      },
    }));
  let n = r(12115),
    a = r(86871),
    o = r(76248);
  async function i(e, t) {
    return new Promise((r, i) => {
      (0, n.startTransition)(() => {
        (0, o.dispatchAppRouterAction)({
          type: a.ACTION_SERVER_ACTION,
          actionId: e,
          actionArgs: t,
          resolve: r,
          reject: i,
        });
      });
    });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
